import { useEffect } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { SYM_A, SYM_B, SYM_VIEWBOX } from "./Logo";

const LAYERS = 16;

const Extrusion = ({ d, from }) => (
  <motion.div
    className="absolute inset-0 [transform-style:preserve-3d]"
    initial={{ x: from.x, y: from.y, opacity: 0 }}
    animate={{ x: 0, y: 0, opacity: 1 }}
    transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1], delay: 0.9 }}
  >
    {Array.from({ length: LAYERS }).map((_, i) => {
      const front = i === LAYERS - 1;
      return (
        <svg key={i} viewBox={SYM_VIEWBOX} className="absolute inset-0 h-full w-full" style={{ transform: `translateZ(${i * 2.2}px)` }}>
          <path d={d} fill={front ? "url(#markFace)" : `rgb(${18 + i * 2}, ${34 + i * 3}, ${70 + i * 5})`} />
        </svg>
      );
    })}
  </motion.div>
);

export const HeroMark = ({ className = "" }) => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-1, 1], [18, -18]), { stiffness: 60, damping: 14 });
  const ry = useSpring(useTransform(mx, [-1, 1], [-26, 26]), { stiffness: 60, damping: 14 });

  useEffect(() => {
    const onMove = (e) => {
      mx.set((e.clientX / window.innerWidth) * 2 - 1);
      my.set((e.clientY / window.innerHeight) * 2 - 1);
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, [mx, my]);

  return (
    <div data-testid="hero-mark" className={`relative aspect-square [perspective:1100px] ${className}`}>
      <svg width="0" height="0" className="absolute">
        <defs>
          <linearGradient id="markFace" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="55%" stopColor="#e3dccc" />
            <stop offset="100%" stopColor="#8fb3d9" />
          </linearGradient>
        </defs>
      </svg>
      <div className="absolute inset-[-10%] rounded-full bg-[radial-gradient(circle,rgba(61,127,217,0.45),transparent_62%)] blur-2xl" />
      <div className="orbit absolute inset-[2%] rounded-full border border-cream/10" />
      <div className="orbit-rev absolute inset-[14%] rounded-full border border-dashed border-skaris-sky/30" />
      <motion.div className="float absolute inset-[22%] [transform-style:preserve-3d]" style={{ rotateX: rx, rotateY: ry }}>
        <div className="absolute inset-0 [transform-style:preserve-3d]" style={{ transform: "rotateY(-18deg) rotateX(8deg)" }}>
          <Extrusion d={SYM_A} from={{ x: -90, y: -70 }} />
          <Extrusion d={SYM_B} from={{ x: 90, y: 70 }} />
        </div>
      </motion.div>
    </div>
  );
};
